import { render, staticRenderFns } from "./SalePage.vue?vue&type=template&id=5748f3c5&scoped=true&"
import script from "./SalePage.vue?vue&type=script&lang=js&"
export * from "./SalePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748f3c5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5748f3c5')) {
      api.createRecord('5748f3c5', component.options)
    } else {
      api.reload('5748f3c5', component.options)
    }
    module.hot.accept("./SalePage.vue?vue&type=template&id=5748f3c5&scoped=true&", function () {
      api.rerender('5748f3c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/SalePage.vue"
export default component.exports